<template>
  <v-container>
    <h1>Erreur 404</h1>
    <p>
      La page/fonction que vous recherchez n'a pas été trouvée sur cette
      application.
    </p>
  </v-container>
</template>

<script>
export default {};
</script>

<style></style>
